export default {"src":"/_next/static/media/pv-logo-color.f6a377a3.svg","height":92,"width":112};